import React from 'react';
import SubmissionDetails from '../../../SubmissionDetails';
import Stats from '../../../Stats';
import s from './Status.scss';
export var StatusDetails = function (_a) {
    var deviation = _a.deviation, _b = _a.deviation, textContent = _b.textContent, publishedTime = _b.publishedTime;
    if (!textContent) {
        return null;
    }
    return (React.createElement("div", { className: s['root'] },
        React.createElement("div", { className: s['details-block'] },
            React.createElement(SubmissionDetails, { deviation: deviation })),
        React.createElement("div", { className: s['stats'] },
            React.createElement(Stats, { deviation: deviation }))));
};
StatusDetails.displayName = 'StatusDetails';
export default StatusDetails;
//# sourceMappingURL=Status.js.map